import React from "react";

const InfoZoneIcon = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 17L5.91 15.09C7.256 13.745 7.928 13.072 8.657 13.01C9.024 12.98 9.392 13.05 9.722 13.215C10.376 13.543 10.75 14.418 11.5 16.167L11.553 16.291C11.879 17.052 12.043 17.433 12.311 17.599C12.52 17.7281 12.7691 17.7758 13.011 17.733C13.321 17.679 13.614 17.386 14.199 16.801L14.312 16.688C15.034 15.966 15.394 15.606 15.803 15.454C16.2526 15.2868 16.7474 15.2868 17.197 15.454C17.606 15.606 17.967 15.966 18.687 16.688L19.439 17.439C19.9722 17.9728 20.6589 18.3266 21.403 18.451C21.278 19.778 20.99 20.667 20.328 21.328C19.157 22.5 17.271 22.5 13.5 22.5H11.5C7.729 22.5 5.843 22.5 4.672 21.328C3.501 20.156 3.5 18.271 3.5 14.5V12.5C3.5 9.66 3.5 7.89 4 6.688V17Z"
      fill="#727272"
    />
    <path
      d="M12.5 4.5H11.5C7.729 4.5 5.843 4.5 4.672 5.672C3.501 6.844 3.5 8.729 3.5 12.5V14.5C3.5 18.271 3.5 20.157 4.672 21.328C5.844 22.499 7.729 22.5 11.5 22.5H13.5C17.271 22.5 19.157 22.5 20.328 21.328C21.499 20.156 21.5 18.271 21.5 14.5V13.5"
      stroke="#727272"
      strokeWidth="2"
    />
    <path
      d="M21.5 4.5V3.5H22.5V4.5H21.5ZM17.125 9.28C16.9173 9.43605 16.657 9.50513 16.3992 9.47261C16.1414 9.44009 15.9064 9.30853 15.744 9.10578C15.5815 8.90303 15.5043 8.64501 15.5288 8.38635C15.5532 8.1277 15.6774 7.88871 15.875 7.72L17.125 9.28ZM20.5 9.5V4.5H22.5V9.5H20.5ZM21.5 5.5H16.5V3.5H21.5V5.5ZM22.125 5.28L17.125 9.28L15.875 7.72L20.875 3.72L22.125 5.28Z"
      fill="#727272"
    />
  </svg>
);

export default InfoZoneIcon;
